import React from "react";

const TermsAndConditionPage = () => {
  return (
    <div className="p-4">
      <p style={{ fontSize: 18 }}>
        <strong>Terms and Conditions of Careerline Education Foundation</strong>
      </p>
      <p>
        These Terms and Conditions (“Terms”) govern the relationship between
        <b>Careerline Education Foundation</b> (“we”, “us”, or “our”) and any
        individual or entity (“you”, “student”, or “client”) who uses or enrolls
        in our services.
      </p>
      <p>
        By engaging with our services, you agree to be bound by these Terms.
      </p>
      <p className="mt-5">
        <strong>1. Scope of Services</strong>
      </p>
      <p>We offer the following services:</p>
      <ul className="ps-4">
        <li>
          Coaching and training for exams including GRE, IELTS, SAT, PTE, and
          Duolingo.
        </li>
        <li>
          Consulting services for international student visas and visitor visas.
        </li>
        <li>
          University admissions guidance, documentation support, and
          pre-departure counselling.
        </li>
      </ul>
      <p className="mt-5">
        <strong>2. Enrollment and Payment</strong>
      </p>
      <p>
        Enrollment is confirmed only after the completion of the registration
        process and the receipt of full or agreed-upon fees. <br />
        All services are subject to the payment terms communicated at the time
        of registration.
        <br />
        Fees paid are non-refundable, except where explicitly stated in our
        Refund Policy.
        <br />
        Payments must be made exclusively through official channels. Careerline
        is not responsible for payments made to unauthorized parties or
        individuals.
      </p>
      <p className="mt-5">
        <strong>3. Attendance and Course Completion</strong>
      </p>
      <p>
        Regular attendance is essential for coaching programs.
        <br />
        Absence without prior notice may lead to the discontinuation of access
        to sessions or materials.
        <br />
        Requests for makeup classes are evaluated on a case-by-case basis and
        depend on availability.
      </p>
      <p className="mt-5">
        <strong>4. Student Responsibilities</strong>
      </p>
      <p>
        Clients must provide accurate and truthful information throughout the
        process.
        <br />
        Any misrepresentation may lead to termination of services without
        refund.
        <br />
        Students are expected to adhere to deadlines and guidelines shared by
        our team.
      </p>
      <p className="mt-5">
        <strong>5. Use of Services</strong>
      </p>
      <p>
        Services provided are for personal and academic purposes only. <br />
        Any commercial use, resale, or sharing of course material is strictly
        prohibited. <br />
        Misuse or abuse of our platform or brand name will result in legal
        action.
      </p>
      <p className="mt-5">
        <strong>6. Code of Conduct</strong>
      </p>
      <p>
        All students are expected to maintain respectful behavior towards staff,
        instructors, and fellow students. <br />
        Harassment, discrimination, or disruptive conduct will not be tolerated
        and may result in suspension or termination without notice or refund.
      </p>
      <p className="mt-5">
        <strong>7. Disclaimer and Limitation of Liability</strong>
      </p>
      <p>
        While we provide professional services and support, we do not guarantee
        exam scores, university admission, or visa approval. <br />
        Final decisions regarding admission or visas are made by respective
        institutions and immigration authorities. <br />
        Careerline shall not be held liable for outcomes that depend on external
        agencies.
      </p>
      <p className="mt-5">
        <strong>8. Confidentiality and Privacy</strong>
      </p>
      <p>
        We maintain strict confidentiality of your personal and academic
        information. <br />
        Your data will only be used for your opted/intended service delivery and
        not shared with third parties without your consent, unless required by
        law.
      </p>
      <p className="mt-5">
        <strong>9. Intellectual Property</strong>
      </p>
      <p>
        All learning materials, course content, and resources are the
        intellectual property of Careerline Education Foundation. Any
        reproduction, distribution, or misuse of materials without written
        consent is strictly prohibited.
      </p>
      <p className="mt-5">
        <strong>10. Third-Party Links and Services</strong>
      </p>
      <p>
        We may refer or connect clients to third-party services (e.g., test
        booking, insurance, forex).
        <br />
        We are not responsible for the performance or outcomes of third-party
        providers.
      </p>
      <p className="mt-5">
        <strong>11. Refund and Cancellation Policy</strong>
      </p>
      <p>
        Refunds are not applicable unless specified in our <b>Refund Policy </b>
        available on request.
        <br />
        In visa services, once the application process has started, the service
        fee becomes non-refundable.
        <br />
        Any cancellation of coaching programs must be communicated in writing.
      </p>
      <p className="mt-5">
        <strong>12. Force Majeure</strong>
      </p>
      <p>
        We are not liable for delays or non-performance due to circumstances
        beyond our control, including but not limited to natural disasters,
        technical failures, government restrictions, or pandemics.
      </p>
      <p className="mt-5">
        <strong>13. Certification and Results</strong>
      </p>
      <p>
        Course completion certificates (if applicable) are issued only upon
        fulfilling attendance and participation requirements.
        <br />
        While we provide support and guidance, success in exams or visa
        approvals depends on individual performance and external authorities.
      </p>
      <p className="mt-5">
        <strong>14. Parental Communication (for Minors)</strong>
      </p>
      <p>
        For students under 18 years of age, we may communicate with parents or
        guardians regarding performance, attendance, or payment issues as
        needed.
      </p>
      <p className="mt-5">
        <strong>15. Online Classes and Recordings</strong>
      </p>
      <p>
        For online coaching, session recordings may be provided when available,
        but are not guaranteed. <br />
        Unauthorized recording or sharing of class content is prohibited.
      </p>
      <p className="mt-5">
        <strong>16. Student Consent</strong>
      </p>
      <p>
        As a client of Careerline Educaiton you agrees and authorize the company
        to record and provide your personal, academic and employment information
        for your intended education, admission and visa purposes with the
        private and/or government agencies contracted or non-contracted with
        Careerline Education. Students also agree that Careerline Education may
        promote information about their success in Exams for which Careerline
        Education has assisted them in scoring good results. With the consent of
        students and also parents when a student is a minor.
      </p>
      <p className="mt-5">
        <strong>17. Amendments and Updates</strong>
      </p>
      <p>
        These Terms may be revised or updated periodically. Any changes will be
        published on our website or communicated via email. <br />
        Continued use of our services after changes constitutes acceptance of
        the updated Terms.
      </p>
      <p className="mt-5">
        <strong>18. Governing Law and Jurisdiction</strong>
      </p>
      <p>
        These Terms shall be governed by the laws of Ahmedabad-India. <br />
        All disputes shall be subject to the jurisdiction of the courts located
        in Ahmedabad.
      </p>
      <p className="mt-5">
        <strong>19. Contact Information</strong>
      </p>
      <p>
        For any questions or clarifications regarding these Terms, please
        contact:
      </p>
      <ul className="ps-5">
        <li>
          Email :{" "}
          <a
            style={{ color: "#000", textDecoration: "none" }}
            href="mailto:admin@careerline.org"
          >
            admin@careerline.org
          </a>
        </li>
        <li>
          Phone No.:{" "}
          <a
            style={{ color: "#000", textDecoration: "none" }}
            href="tel:+916358989872"
          >
            +91-6358989872
          </a>
        </li>
        <li>
          Website :{" "}
          <a href="https://careerline.org/" target="_blank">
            https://careerline.org/
          </a>
        </li>
        <li>
          Office Address:{" "}
          <a
            href="https://maps.app.goo.gl/ZTEbFhBzpUVc6MmK8"
            target="_blank"
            style={{ color: "#000", textDecoration: "none" }}
          >
            601-608, AWS-III Block-A, Nr. Manav Mandir, Memnagar
            Ahmedabad-380052, Gujarat, India.
          </a>
        </li>
      </ul>

      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </div>
  );
};

export default TermsAndConditionPage;
